import { PaginatedResponse } from "@elit-hair/elit-tools";

// Pagination constants (matches backend environment variables)
export const PAGINATION = {
    // Default page number (matches backend PAGE = 1)
    DEFAULT_PAGE: 1,
    // Default page size (matches backend PAGE_SIZE = 25)
    PAGE_SIZE: 25,
} as const;

// Default empty pagination response
export const DEFAULT_EMPTY_PAGINATION: PaginatedResponse<unknown>["pagination"] = {
    page: PAGINATION.DEFAULT_PAGE,
    limit: PAGINATION.PAGE_SIZE,
    count: 0,
    hasMore: false,
    total: 0,
} as const;

// Utility function to get pagination info text
export const getPaginationInfo = (currentPage: number, pageSize: number, total: number) => {
    const startItem = (currentPage - 1) * pageSize + 1;
    const endItem = Math.min(currentPage * pageSize, total);
    return {
        startItem,
        endItem,
        total,
        text: `${startItem}-${endItem} of ${total}`,
    };
};

// Calculate total pages
export const getTotalPages = (total: number, pageSize: number) => {
    return Math.ceil(total / pageSize);
};
